import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import "./CreateGroupModal.css";

const ConfirmationModal = ({ show, onClose, onConfirm, message }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title><span style={{ fontSize: "18px" }}>Confirmation</span></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className='cance-button' onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" className='create-button' onClick={onConfirm}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
